import ViewPadrao from "../views/ViewPadrao";
import PacoteDocumentoList from "../views/PacoteDocumentoList";
import PacoteDocumentoForm from "../views/PacoteDocumentoForm";
import PacoteDocumentoDocumentos from '../views/PacoteDocumentoDocumentos';

export default {
  path: "pacote-documentos",
  component: ViewPadrao,
  children: [
    {
      path: "",
      name: "pacote-documento-list",
      component: PacoteDocumentoList,
      meta: {
        auth: true,
        perms: ["documentos.listar_pacotes"],
      },
    },
    {
      path: "novo",
      name: "pacote-documento-novo",
      component: PacoteDocumentoForm,
      meta: {
        auth: true,
        perms: ["documentos.editar_pacotes"],
      },
    },
    {
      path: "editar/:id",
      name: "pacote-documento-detalhes",
      component: PacoteDocumentoForm,
      meta: {
        auth: true,
        perms: ["documentos.editar_pacotes"],
      },
    },
    {
      path: "documentos/:id",
      name: "pacote-documento-docs",
      component: PacoteDocumentoDocumentos,
      meta: {
        auth: true,
      },
    },
  ],
};
